// Timestamp conversion constants for different breakdown periods
export const TIMESTAMP_OPTIONS = {
	minutes: 1000 * 60 * 5,
	hours: 1000 * 60 * 60,
	days: 1000 * 60 * 60 * 24,
	weeks: 1000 * 60 * 60 * 24 * 7,
	months: 1000 * 60 * 60 * 24 * 31,
};

// Attribute configurations for metrics building
export const ATTRIBUTE_CONFIGS = [
	{ tag: 'Current Cash', aggregator: 'max' },
	{ tag: 'Remote', aggregator: 'last' },
	{ tag: 'People', aggregator: 'last' },
	{ tag: 'Fingerprint', aggregator: 'last' },
	{ tag: 'Keycard', aggregator: 'last' },
];

// Feed type names for mapping query results to feed lists
export const FEED_TYPES = {
	CURRENT_CASH: 'Current Cash',
	REVENUE: 'Revenue',
	REMOTE: 'Remote',
	PEOPLE: 'People',
	FINGERPRINT: 'Fingerprint',
	KEYCARD: 'Keycard',
};
